// Helper genérico para carregar estados/cidades do IBGE com fallback em JSON local
// Uso:
//   window.IBGE.initStateCitySelect({
//     stateSelector: '#chief_state',
//     citySelector:  '#chief_city',
//     currentState:  'SP',   // opcional
//     currentCity:   'São Paulo' // opcional
//   });

function normalizeLocationValue(value) {
  if (!value) return "";
  var decomposed = value.normalize("NFD");
  var stripped = "";
  for (var i = 0; i < decomposed.length; i++) {
    var code = decomposed.charCodeAt(i);
    // Unicode combining diacritical marks block (0x0300-0x036f): drop accents.
    if (code < 0x0300 || code > 0x036f) {
      stripped += decomposed[i];
    }
  }
  return stripped.trim().toLowerCase();
}

function buildSyntheticSelectedOption(value) {
  const option = document.createElement("option");
  option.value = value;
  option.text = value;
  option.selected = true;
  return option;
}

function clearInvalidIfFilled(field) {
  if (!field) return;

  // Só se for required e tiver valor
  if (field.hasAttribute("required") && field.value) {
    field.classList.remove("is-invalid");
    const feedback = field.nextElementSibling;
    if (feedback && feedback.classList.contains("invalid-feedback")) {
      feedback.style.display = "none";
    }
  }
}

async function loadLocalIbgeData() {
  if (window.__ibgeLocalCache) return window.__ibgeLocalCache;

  const response = await fetch("/ibge_locations.json", { cache: "reload" });
  if (!response.ok) throw new Error("Erro ao carregar JSON local de IBGE");

  const data = await response.json();
  window.__ibgeLocalCache = data;
  return data;
}

async function fetchStatesFromApi() {
  const response = await fetch(
    "https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome"
  );
  if (!response.ok) throw new Error("Erro HTTP na API de estados");
  return await response.json();
}

async function fetchStatesFromLocal() {
  const data = await loadLocalIbgeData();
  return data.estados || [];
}

async function fetchCitiesFromApi(uf) {
  const response = await fetch(
    `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`
  );
  if (!response.ok) throw new Error("Erro HTTP na API de cidades");
  return await response.json();
}

async function fetchCitiesFromLocal(uf) {
  const data = await loadLocalIbgeData();
  if (!data.cidades_por_uf) return [];
  return data.cidades_por_uf[uf] || [];
}

async function loadStatesIntoSelect(selectEl, currentValue) {
  if (!selectEl) return;

  let states = [];
  try {
    states = await fetchStatesFromApi();
  } catch (e) {
    console.error("Erro ao carregar estados IBGE, tentando JSON local...", e);
    try {
      states = await fetchStatesFromLocal();
    } catch (e2) {
      console.error("Erro ao carregar estados do JSON local de IBGE", e2);
      return;
    }
  }

  if (!states || !states.length) return;

  const normalizedCurrent = normalizeLocationValue(currentValue);
  const placeholder = selectEl.options[0]
    ? selectEl.options[0].cloneNode(true)
    : null;
  selectEl.innerHTML = "";
  if (placeholder) selectEl.appendChild(placeholder);

  let matched = false;
  states.forEach((uf) => {
    const option = document.createElement("option");
    option.value = uf.sigla;
    option.text = `${uf.nome} (${uf.sigla})`;
    if (
      normalizedCurrent &&
      (normalizedCurrent === normalizeLocationValue(uf.sigla) ||
        normalizedCurrent === normalizeLocationValue(uf.nome))
    ) {
      option.selected = true;
      matched = true;
    }
    selectEl.appendChild(option);
  });

  // Valor salvo não casou com nenhuma UF (grafia divergente) — mantém o
  // valor em vez de deixar o placeholder selecionado por omissão.
  if (!matched && currentValue) {
    selectEl.appendChild(buildSyntheticSelectedOption(currentValue));
  }

  // Se já vier preenchido (valor atual / banco), limpa erro visual
  clearInvalidIfFilled(selectEl);
}

async function loadCitiesIntoSelect(selectEl, uf, currentValue) {
  if (!selectEl || !uf) return;

  let cities = [];
  try {
    cities = await fetchCitiesFromApi(uf);
  } catch (e) {
    console.error("Erro ao carregar cidades IBGE, tentando JSON local...", e);
    try {
      cities = await fetchCitiesFromLocal(uf);
    } catch (e2) {
      console.error("Erro ao carregar cidades do JSON local de IBGE", e2);
      return;
    }
  }

  if (!cities || !cities.length) return;

  const normalizedCurrent = normalizeLocationValue(currentValue);
  const placeholder = selectEl.options[0]
    ? selectEl.options[0].cloneNode(true)
    : null;
  selectEl.innerHTML = "";
  if (placeholder) selectEl.appendChild(placeholder);

  let matched = false;
  cities.forEach((city) => {
    const option = document.createElement("option");
    option.value = city.nome;
    option.text = city.nome;
    if (normalizedCurrent && normalizedCurrent === normalizeLocationValue(city.nome)) {
      option.selected = true;
      matched = true;
    }
    selectEl.appendChild(option);
  });

  // Valor salvo não casou com nenhum município IBGE (acento/grafia) —
  // mantém o valor em vez de deixar o placeholder selecionado por omissão.
  if (!matched && currentValue) {
    selectEl.appendChild(buildSyntheticSelectedOption(currentValue));
  }

  // Se já vier preenchido (valor atual / banco), limpa erro visual
  clearInvalidIfFilled(selectEl);
}

function initStateCitySelect({
  stateSelector,
  citySelector,
  currentState,
  currentCity,
}) {
  const stateSelect = document.querySelector(stateSelector);
  const citySelect = citySelector ? document.querySelector(citySelector) : null;

  if (!stateSelect) return;

  const stateValue =
    currentState ||
    stateSelect.dataset.current_value ||
    stateSelect.dataset.currentValue;
  const cityValue =
    currentCity ||
    (citySelect &&
      (citySelect.dataset.current_value || citySelect.dataset.currentValue));

  loadStatesIntoSelect(stateSelect, stateValue).then(() => {
    // Usa o valor resolvido do select (sigla, se o match encontrou a UF)
    // em vez do stateValue bruto — evita bater na API de cidades com um
    // nome de estado por extenso quando o salvo não estava na sigla.
    const resolvedState = stateSelect.value || stateValue;
    if (resolvedState && citySelect) {
      loadCitiesIntoSelect(citySelect, resolvedState, cityValue);
    }
  });

  if (citySelect) {
    stateSelect.addEventListener("change", (event) => {
      const uf = event.target.value;
      if (!uf) return;

      // limpa city "salva" para forçar nova seleção
      citySelect.dataset.current_value = "";
      citySelect.dataset.currentValue = "";
      loadCitiesIntoSelect(citySelect, uf, null);
    });
  }
}

// expõe globalmente
if (!window.IBGE) window.IBGE = {};
window.IBGE.initStateCitySelect = initStateCitySelect;

